module.exports = __webpack_public_path__ + "images/FUSA_icons/021-safebox.7244b90845dc15534acbcf59ef296673.svg";